import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';

import { FilterBarModule, MatcherComponentRegistryService } from '@cdw-ae/filter-bar-core';
import { DateTimeMatcherComponent } from './matchers/date-time.matcher';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialLibraryModule,
    FilterBarModule,
  ],
  declarations: [DateTimeMatcherComponent],
  exports: [DateTimeMatcherComponent],
})
export class FilterBarTemporalMatchersModule {
  constructor(private matcherRegistry: MatcherComponentRegistryService) {
    // Register temporal matcher components
    this.matcherRegistry.registerComponent('dateTime', DateTimeMatcherComponent);
  }
}
